import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconChat = ({ className, height, width, fill }: IconInterface) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='0 0 33 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.51562 8.38291C3.51562 7.26217 4.45251 6.35364 5.60822 6.35364H27.9596C29.1153 6.35364 30.0522 7.26217 30.0522 8.38291C30.0522 9.50364 29.1153 10.4122 27.9596 10.4122H5.60822C4.45251 10.4122 3.51562 9.50364 3.51562 8.38291Z'
      fill={fill}
    />
    <path
      d='M3.51562 16.5C3.51562 15.3792 4.45251 14.4707 5.60822 14.4707H27.9596C29.1153 14.4707 30.0522 15.3792 30.0522 16.5C30.0522 17.6207 29.1153 18.5292 27.9596 18.5292H5.60822C4.45251 18.5292 3.51562 17.6207 3.51562 16.5Z'
      fill={fill}
    />
    <path
      d='M3.51562 24.6171C3.51562 23.4963 4.45251 22.5878 5.60822 22.5878H27.9596C29.1153 22.5878 30.0522 23.4963 30.0522 24.6171C30.0522 25.7378 29.1153 26.6463 27.9596 26.6463H5.60822C4.45251 26.6463 3.51562 25.7378 3.51562 24.6171Z'
      fill={fill}
    />
  </svg>
)

export default Icon(IconChat)
